module.exports = __webpack_public_path__ + "static/media/forgotBg.7e1742f7.png";